
    <label class="checkbox has-left-padding" *ngFor="let elem of formVariable.formVariableValues ; let elemIdx = index">
      <input type="checkbox"> {{elem.validValueDesc}}
    </label>
 